<template>
  <header>
    <div class="container">
      <div class="logo-header">
        <router-link :to="{ name: 'Home' }">
          <img alt="Portal Ulbrex" src="~@/assets/logo.svg" />
        </router-link>
      </div>
      <div class="navigation-header" :class="{ 'is-active': activeMenu }">
        <nav class="nav">
          <router-link :to="{ name: 'About' }" exact
            ><span @click="toggleMenu()">Sobre</span></router-link
          >
          <router-link :to="{ name: 'Blog' }" exact
            ><span @click="toggleMenu()">Blog</span></router-link
          >
          <a href="#contato"><span @click="toggleMenu()">Contato</span></a>
        </nav>
        <div class="products">
          <button class="button-primary" @click="openWhatsappModal">
            Fale com um especialista
          </button>
          <!-- Referência ao componente WhatsApp -->
          <WhatsAppButton ref="whatsappRef" />
        </div>
      </div>

    </div>
  </header>
</template>

<script>
import WhatsAppButton from '@/components/WhatsAppButton.vue'

export default {
  name: 'Header',
  components: {
    WhatsAppButton
  },
  data() {
    return {
      activeMenu: false
    }
  },
  methods: {
    toggleMenu() {
      this.activeMenu = !this.activeMenu
    },
    openWhatsappModal() {
      // Acessa o componente filho via ref e mostra o modal
      this.$refs.whatsappRef.showModal = true
    }
  }
}
</script>


<style lang="scss" scoped>
header {
  background: var(--white);
  height: 80px;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  z-index: 20;
  align-items: center;

  .container {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
  }

  .logo-header {
    display: flex;
    align-items: center;

    a {
      display: flex;
    }
    img {
      display: block;
      height: 27px;
    }
  }

  .navigation-header {
    display: flex;
    align-items: center;

    .nav {
      a {
        color: var(--secundary-black);
        font-weight: 400;
        font-size: calc(var(--size-regular) - 2px);
        line-height: 29px;
        font-family: var(--font-primary);
        padding: 0 20px;
        text-decoration: none;
        transition: all 0.2s ease-in-out;

        &:hover,
        &:active,
        &:focus {
          color: var(--light-blue);
          transition: all 0.2s ease-in-out;
        }
      }
    }

    .products {
      button {
        border: none;
      }
    }

    .search {
      .button-primary {
        min-width: 207px;
        margin: 0 44px 0 64px;
      }
    }

    .social {
      margin-left: 20px;

      a {
        outline: none;
        cursor: pointer;
        img {
          display: block;
        }
      }
    }
  }

  .hamburger {
    display: none;
  }

  @media (max-width: 768px) {
    height: 60px;
    position: fixed;
    width: 100%;

    .logo-header img {
      width: 100px;
    }
    .hamburger {
      display: inline-block;
    }
    .navigation-header {
      position: fixed;
      height: calc(100% - 60px);
      top: 59px;
      left: -320px;
      width: 300px;
      background: var(--white);
      z-index: 9;
      box-shadow: 0px 40px 40px rgba(0, 0, 0, 0.2);
      padding: 0 0;
      transition: all 200ms ease-out;
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .products {
        margin-left: 20px;
      }

      .social {
        display: none;
      }

      .nav {
        width: 100%;
        margin-bottom: 12px;
        a {
          display: block;

          span {
            padding: 12px 16px;
            display: block;
          }

          &:hover,
          &:active,
          &:focus,
          &.router-link-active {
            background: var(--light-blue);
            color: var(--white);
          }
        }
      }

      .button-primary {
        margin-right: 20px;
      }

      .search {
        width: 100%;
        padding: 0 16px;
        .button-primary {
          margin: 0 0;
        }
      }

      &.is-active {
        left: 0;
        transition: all 200ms ease-out;
      }
    }
  }
}
</style>
